import CalendarGenerator from './CalendarGenerator';

export default CalendarGenerator('calendar-search');
